const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
//const Backofficebff         : string = "/backofficebff/service/api/v1";
export const CacheCommand: any = {
    RemoveCacheKey: Backofficebff + '/v1/managecache/remove-cachekey',
    ClearCacheKey: Backofficebff + '/v1/managecache/clear-cachekey',
    RemoveCacheTeam: Backofficebff + '/v1/managecache/delete-ecommerceteam',
    PostTeam: Backofficebff + '/v1/managecache/create-ecommerceteam',
    PostCreateCash: Backofficebff + '/v1/managecache/create-cachemanagement',
    UpdateCreateCash: Backofficebff + '/v1/managecache/update-cachemanagement',
    DeleteRedisKey: Backofficebff + '/managecache/delete-redis-by-key',
    BulkDeleteRedisKeys: Backofficebff + '/managecache/bulk-delete-cache',
};
